import React from 'react'
import { Tooltip } from 'react-tooltip'

const t = {
    FR: {
        specifics_career: {'page title': 'Carrière',},

        'My profile title': 'Mon profil',
        'My profile content': <>
            <p><b>Louys Patrice Bessette</b> est un développeur web passionné et nomade numérique originaire du Québec, actuellement installé en Uruguay.</p>

            <div className='center'>
                <img className='maxWidth300' alt='map' src='/America-del-Sur_soy-aqui.png' />
            </div>

            <p>Trilingue, Louys parle couramment le français, l'anglais et l'espagnol. Il a élu domicile en Uruguay depuis mars 2023, une date qui coïncide avec son 49e anniversaire. Il considère ce déménagement comme une étape importante et un cadeau significatif qu'il s'est offert.</p>

            <p>Contributeur actif sur <a target='Stack Overflow' href='https://stackoverflow.com/users/2159528/louys-patrice-bessette'>Stack Overflow</a>, Louys a publié 1&nbsp;889 réponses, atteignant un score de réputation impressionnant de 33.8 k. Ses contributions lui ont valu de nombreuses distinctions, dont sept badges en or, témoignant de son expertise et de son engagement envers la communauté des développeurs.</p>

            <p>Il est disponible pour travailler dans les fuseaux horaires des Amériques, allant de UTC&#8209;3 à UTC&#8209;8.</p>

            <p className='smallItalic alignRight'>(Généré par l'IA)</p>
        </>,
        'cv': <>
            <p>
                Consultez mon <a target='cv' href='/files/cv/francais.pdf'>curriculum Vitae. <box-icon type='solid' name='file-pdf' /></a><br />
                <span className='smallItalic alignRight'>Ne contient aucune information de contact en raison de spam / appels téléphoniques non sollicités.</span>
            </p>
        </>,

        'To contact me title': 'Pour me contacter',
        'To contact me content': <>
            <p>
                Vous pouvez réserver une <a target='calendly' href='https://calendly.com/louys-patrice-bessette/bonjour-welcome-hola?month=2024-11'>réunion vidéo</a> avec moi&nbsp;!<br />

                Je vous serais reconnaissant de <b>remplir ce formulaire&nbsp;!</b><br />
                &nbsp;&nbsp;&nbsp;<span className='smallItalic'>Prévoyez environ 24&nbsp;heures pour une réponse.</span>
            </p>
        </>,

        // FORM
        'Company': 'Compagnie',
        'Company name': 'Nom de la compagnie',
        'Company website': 'Site web de la compagnie',
        'Position title': 'Titre du poste',
        'Position placeholder': 'Développeur',
        'Job posting link': `Lien de l'affichage du poste:`,
        'Timezone': 'Fuseau horaire',
        'Select': 'Selectionnez',
        'Not a requirement': `N'est pas requis`,
        'Contact': 'Contact',
        'Type': 'Type',
        'Employer': 'Employeur(e)',
        'Recruiter': 'Recruteur(e)',
        'Name': 'Nom',
        'Phone': 'Téléphone',
        'One of the 3 below is required.': `L'une des 3 conditions ci-dessous est requise.`,
        'LinkedIn': 'LinkedIn',
        'BlueSky': 'BlueSky',
        'Email': 'Courriel',
        'Message': 'Message',
        'Message placeholder': 'Message...',
        'Thanks! Your message was sent.': 'Merci! Votre message a été envoyé.',
    },
    EN: {
        specifics_career: {'page title': 'Career',},

        'My profile title': 'My profile',
        'My profile content': <>
            <p><b>Louys Patrice Bessette</b> is a passionate web developer and digital nomad hailing from Quebec, currently based in Uruguay.</p>

            <div className='center'>
                <img className='maxWidth300' alt='map' src='/America-del-Sur_soy-aqui.png' />
            </div>

            <p>Fluent in French, English, and Spanish, Louys is trilingual and has been calling Uruguay home since March 2023. This move coincided with his 49th birthday, which he considers a personal milestone and a meaningful gift to himself.</p>

            <p>An active contributor on <a target='Stack Overflow' href='https://stackoverflow.com/users/2159528/louys-patrice-bessette'>Stack Overflow</a>, Louys has provided 1,889 answers, earning an impressive reputation score of 33.8k. His contributions have been recognized with multiple badges, including seven gold badges, reflecting his expertise and commitment to the developer community.</p>

            <p>He is available to work within the Americas time zones, from UTC&#8209;3 to UTC&#8209;8.</p>

            <p className='smallItalic alignRight'>(AI generated)</p>
        </>,
        'cv': <>
            <p>
                Check out my <a target='cv' href='/files/cv/english.pdf'>resume. <box-icon type='solid' name='file-pdf' /></a><br />
                <span className='smallItalic alignRight'>Contains no contact information due to spam / unsollicited phone calls.</span>
            </p>
        </>,

        'To contact me title': 'To contact me',
        'To contact me content': <>
            <p>
                You can book a <a target='calendly' href='https://calendly.com/louys-patrice-bessette/bonjour-welcome-hola?month=2024-11'>video meeting</a> with me!<br />

                I would appreciate you <b>fill this form!</b><br />
                &nbsp;&nbsp;&nbsp;<span className='smallItalic'>Allow ~24 hours for a reply.</span>
            </p>
        </>,

        // FORM
        'Company': 'Company',
        'Company name': 'Company name',
        'Company website': 'Company website',
        'Position title': 'Position title',
        'Position placeholder': 'Developer',
        'Job posting link': 'Job posting link',
        'Timezone': 'Timezone',
        'Select': 'Select',
        'Not a requirement': 'Not a requirement',
        'Contact': 'Contact',
        'Type': 'Type',
        'Employer': 'Employer',
        'Recruiter': 'Recruiter',
        'Name': 'Name',
        'Phone': 'Phone',
        'One of the 3 below is required.': 'One of the 3 below is required.',
        'LinkedIn': 'LinkedIn',
        'BlueSky': 'BlueSky',
        'Email': 'Email',
        'Message': 'Message',
        'Message placeholder': 'Message...',
        'Thanks! Your message was sent.': 'Thanks! Your message was sent.',
    },
    ES: {
        specifics_career: {'page title': 'Carrera',},

        'My profile title': 'Mi perfil',
        'My profile content': <>
            <p><b>Louys Patrice Bessette</b> es un apasionado desarrollador web y nómada digital originario de Quebec, actualmente residente en Uruguay.</p>

            <div className='center'>
                <img className='maxWidth300' alt='map' src='/America-del-Sur_soy-aqui.png' />
            </div>

            <p>Trilingüe y fluido en francés, inglés y español, Louys ha considerado Uruguay su hogar desde marzo de 2023. Este cambio coincidió con su 49.º cumpleaños, un hito personal que él describe como un regalo significativo para sí mismo.</p>

            <p>Como colaborador destacado en <a target='Stack Overflow' href='https://stackoverflow.com/users/2159528/louys-patrice-bessette'>Stack Overflow</a>, Louys ha aportado 1,889 respuestas, logrando una impresionante puntuación de reputación de 33.8k. Sus contribuciones han sido reconocidas con múltiples insignias, incluidas siete de oro, lo que refleja su experiencia y dedicación a la comunidad de desarrolladores.</p>

            <p>Está disponible para trabajar en los husos horarios de las Américas, desde UTC&#8209;3 hasta UTC&#8209;8.</p>

            <p className='smallItalic alignRight'>(IA generada)</p>
        </>,
        'cv': <>
            <p>
                Ver mi <a target='cv' href='/files/cv/espanol.pdf'>CV. <box-icon type='solid' name='file-pdf' /></a><br />
                <span className='smallItalic alignRight'>No contiene información de contacto debido a spam / llamadas telefónicas no solicitadas.</span>
            </p>
        </>,

        'To contact me title': 'Para contactarme',
        'To contact me content': <>
            <p>
                ¡Puedes reservar una <a target='calendly' href='https://calendly.com/louys-patrice-bessette/bonjour-welcome-hola?month=2024-11'>reunión por video</a> conmigo!<br />

                ¡Te agradecería que completaras <b>este formulario!</b><br />
                &nbsp;&nbsp;&nbsp;<span className='smallItalic'>Espera aproximadamente 24 horas para recibir una respuesta.</span>
            </p>
        </>,

        // FORM
        'Company': 'Empresa',
        'Company name': 'Nombre de empresa',
        'Company website': 'Sitio web de la empresa',
        'Position title': 'Título del puesto',
        'Position placeholder': 'Desarrollador',
        'Job posting link': 'Enlace de publicación de empleo',
        'Timezone': 'Zona horaria',
        'Select': 'Seleccionar',
        'Not a requirement': 'No es un requisito',
        'Contact': 'Contacto',
        'Type': 'Tipo',
        'Employer': 'Empleador(a)',
        'Recruiter': 'Reclutador(a)',
        'Name': 'Nombre',
        'Phone': 'Teléfono',
        'One of the 3 below is required.': 'Se requiere uno de los 3 siguientes.',
        'LinkedIn': 'LinkedIn',
        'BlueSky': 'BlueSky',
        'Email': 'Correo electrónico',
        'Message': 'Mensaje',
        'Message placeholder': 'Mensaje...',
        'Thanks! Your message was sent.': '¡Gracias! Tu mensaje fue enviado.',
    },
    PT: {
        specifics_career: {'page title': 'Carreira',},

        'My profile title': 'Meu perfil',
        'My profile content': <>
            <p>
                <b>Louys Patrice Bessette</b> é um desenvolvedor web apaixonado e nômade digital natural de Quebec, atualmente baseado no Uruguai.
            </p>

            <div className='center'>
                <img className='maxWidth300' alt='mapa' src='/America-del-Sur_soy-aqui.png' />
            </div>

            <p>
                Fluente em francês, inglês e espanhol, Louys é trilíngue e chama o Uruguai de lar desde março de 2023. Essa mudança coincidiu com seu 49º aniversário, que ele considera um marco pessoal e um presente significativo para si mesmo.
            </p>

            <p>
                Contribuidor ativo no <a target='Stack Overflow' href='https://stackoverflow.com/users/2159528/louys-patrice-bessette'>Stack Overflow</a>, Louys já forneceu 1.889 respostas, ganhando uma pontuação de reputação impressionante de 33.8k. Suas contribuições foram reconhecidas com múltiplos badges, incluindo sete de ouro, refletindo sua expertise e compromisso com a comunidade de desenvolvedores.
            </p>

            <p>
                Ele está disponível para trabalhar nos fusos horários das Américas, de UTC&#8209;3 a UTC&#8209;8.
            </p>

            <p className='smallItalic alignRight'>(Gerado por IA)</p>
        </>,
        cv: <>
            <p>
                <span>Confira meu currículo.</span>
                <Tooltip id='unavailable-cv-pt' clickable></Tooltip>
                <box-icon
                    type='solid'
                    name='file-pdf'
                    data-tooltip-id='unavailable-cv-pt'
                    data-tooltip-content='Versão indisponível'
                    data-tooltip-place='top'
                />

                <br />
                <span className='smallItalic alignRight'>
                    Não contém informações de contato devido a spam/ligação indesejada.
                </span>
            </p>
        </>,

        'To contact me title': 'Para entrar em contato comigo',
        'To contact me content': <>
            <p>
                Você pode agendar uma <a target='calendly' href='https://calendly.com/louys-patrice-bessette/bonjour-welcome-hola?month=2024-11'> reunião por vídeo</a> comigo!<br />
                    
                Eu apreciaria se você <b>preencher este formulário!</b><br />
                &nbsp;&nbsp;&nbsp;<span className='smallItalic'>Aguarde ~24 horas para uma resposta.</span>
            </p>
        </>,

        // FORM
        Company: 'Empresa',
        'Company name': 'Nome da empresa',
        'Company website': 'Site da empresa',
        'Position title': 'Título do cargo',
        'Position placeholder': 'Desenvolvedor',
        'Job posting link': 'Link da vaga',
        Timezone: 'Fuso horário',
        Select: 'Selecionar',
        'Not a requirement': 'Não é obrigatório',
        Contact: 'Contato',
        Type: 'Tipo',
        Employer: 'Empregador',
        Recruiter: 'Recrutador',
        Name: 'Nome',
        Phone: 'Telefone',
        'One of the 3 below is required.': 'Um dos 3 abaixo é obrigatório.',
        LinkedIn: 'LinkedIn',
        BlueSky: 'BlueSky',
        Email: 'E-mail',
        Message: 'Mensagem',
        'Message placeholder': 'Mensagem...',
        'Thanks! Your message was sent.': 'Obrigado! Sua mensagem foi enviada.',
    },
}

export default t